require('./index.scss')

import { lazy, Suspense, useRef, useState } from 'react'
import Dropdown from 'react-bootstrap/Dropdown'
import MediaQuery from 'react-responsive'

import Spinner from '@/components/Spinner'
import screenSizes from '@/constants/screen_sizes'

import CloseButton from './components/CloseButton'
import Hamburger from './components/Hamburger'

const MenuContent = lazy(() => import('./components/MenuContent'))

const MobileMenu = () => {
  const [isShowing, setIsShowing] = useState(false)
  const toggleRef = useRef(null)

  const onToggle = (isOpen, event, metadata) => {
    if (isOpen === false && event?.pointerType !== 'mouse') {
      toggleRef.current.focus()
    }

    if (metadata?.source === 'select') {
      setIsShowing(true)
      return
    }
    setIsShowing(isOpen)
  }

  return(
    <MediaQuery maxWidth={screenSizes.md} >
      <Dropdown
        className='mobile-menu__dropdown'
        onToggle={onToggle}
        show={isShowing}
      >
        <Dropdown.Toggle as={Hamburger} isShowing={isShowing} ref={toggleRef} />
        <Dropdown.Menu>
          <Dropdown.Toggle as={CloseButton} isShowing={isShowing} />
          <Suspense fallback={<Spinner />}>
            <MenuContent toggleMenu={onToggle} />
          </Suspense>
        </Dropdown.Menu>
      </Dropdown>
    </MediaQuery>
  )
}

export default MobileMenu
